const APP_API_BASE = '/api/app/7.0';
const AUTH_API_BASE = '/api/auth/6';
const EVENTS_WS_API_BASE = '/api/events-ws/6.2';
const GRAPH_API_BASE = '/api/graph/7';
const GRAPH_WS_API_BASE = '/api/graph-ws/6.1';
const IAM_API_BASE = '/api/iam/6.1';
const KI_API_BASE = '/api/ki/6';
const KNOWLEDGE_API_BASE = '/api/knowledge/1';
const VARIABLES_API_BASE = '/api/variables/6';
const ACTION_LOG_API_BASE = '/api/audit/1.0';

export {
    APP_API_BASE,
    AUTH_API_BASE,
    EVENTS_WS_API_BASE,
    GRAPH_API_BASE,
    GRAPH_WS_API_BASE,
    IAM_API_BASE,
    KI_API_BASE,
    KNOWLEDGE_API_BASE,
    VARIABLES_API_BASE,
    ACTION_LOG_API_BASE,
};
